import React from 'react';
import FormFieldList from '@/forms/components/FormFieldList';
import formFieldType, { formFieldText } from '@/forms/helper';
import Selectors from '../hooks/selectors';
import Events from '../../catalogue/hooks/events';
import DatasetEvents from '../../hooks/events';
import fieldComponents from '../fields';

const CatalogueFieldList = ({
  category,
  children,
  code,
  direction,
  section,
}) => {
  const state = Selectors.useCatalogueFieldList({ category, code, section });
  const editDataset = DatasetEvents.useEditDataset(category, { code });
  const updateProperties = Events.useUpdateDatasetCatalogueProperties(category, { code });

  return (
    <FormFieldList
      canEdit={state.canEdit}
      category={category}
      className="aridhia-catalogue-field-list"
      code={code}
      component={(f) => fieldComponents[formFieldType(f)]}
      direction={direction}
      fields={state.fields}
      isEditing={state.isEditing}
      onChange={({ properties, names }) => updateProperties({
        properties, fields: names, entity: section, template: state.template,
      })}
      saveErrors={state.saveErrors}
      saveStatus={state.saveStatus}
      section={section}
      showEdit={() => editDataset(state)}
      text={(f) => formFieldText(state.dataset, f, 'catalogue.')}
    >
      {children}
    </FormFieldList>
  );
};

export default CatalogueFieldList;
